export default {
    staffLists:'/index.php/cqh/EmployeeExt/lists',//人员权限列表
    startOff:'/index.php/cqh/EmployeeExt/startOff',//启用禁用人员
    editPartArea:'/index.php/cqh/EmployeeExt/editPartArea',//修改人员角色和区域
    addUser:'/index.php/cqh/Employeeext/AddUser',//新增用户
    getRemindConfig:'/index.php/cqh/Remind/GetRemindConfig', //获取项目提醒设置
    saveRemindConfig:'/index.php/cqh/Remind/SaveRemindConfig', //保存项目提醒设置
}
